import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { Tooltip } from 'react-tooltip';

import { Text } from '@thefarmersfront/kitchen';

import { useTooltipStore } from '~/store';

/**
 * React-Tooltip 라이브러리를 사용한 툴팁 컴포넌트 (테이블 헤더 전용)
 */
const ReactTooltip = () => {
  const { tooltip } = useTooltipStore();

  const portalRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div id="react-tooltip-portal" ref={portalRef} />
      {portalRef.current &&
        createPortal(
          <Tooltip
            className="react-tooltip"
            classNameArrow="react-tooltip-arrow"
            style={{ maxWidth: tooltip?.maxWidth }}
            id="react-tooltip"
            place="bottom-start"
            delayShow={0.4}
            offset={4}
            isOpen={tooltip?.show}
          >
            {tooltip?.title && (
              <Text size="medium" weight="semi-bold" color="white">
                {tooltip?.title}
              </Text>
            )}
            <Text size="small" color="white">
              {tooltip?.description}
            </Text>
          </Tooltip>,
          portalRef.current
        )}
    </>
  );
};

export default ReactTooltip;
